module.exports = __webpack_public_path__ + "static/media/roller10.5956a8ef.jpeg";